import "./allStoreCanvas.scss";
import React from "react";
import { Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PoweredByReeloFooter from "../PoweredByReeloFooter";
import { getFullImageUrl } from "../../../../../../utils/constants/constants";
import { getPublicLoyalty } from "../../../../../../redux/actions/qrCodeActions";
import { setShortlinkData } from "../../../../../../redux/actions/shortlinkActions";

const AllStoresCanvas = ({ isOpen, toggleCanvas, activeStores }) => {
  const dispatch = useDispatch();
  const initData = useSelector((state) => state?.shortLink?.initData);

  const data = {
    textColor:
      initData?.loyalty?.colors?.text ||
      initData?.feedback?.settings?.colors?.text,
    themeColor:
      initData?.loyalty?.colors?.theme ||
      initData?.feedback?.settings?.colors?.theme,
    storeName: initData?.store?.name,
    logo: initData?.loyalty?.logo || initData?.feedback?.settings?.logo,
  };

  const handleStoreClick = (store) => {
    dispatch(getPublicLoyalty(store?._id || store?.id)).then((loyalty) => {
      dispatch(
        setShortlinkData({
          ...initData,
          store,
          loyalty,
        })
      );
      toggleCanvas(!isOpen);
    });
  };

  return (
    <Offcanvas
      show={isOpen}
      placement="bottom"
      onHide={toggleCanvas}
      className="all-store-loyalty-canvas"
    >
      <Offcanvas.Body>
        <div
          className="all-store-canvas-header"
          style={{
            backgroundColor: data.themeColor,
          }}
        >
          <span onClick={toggleCanvas}>
            <img src="/assets/icons/arrow-left.svg" alt="back" />
            Back
          </span>
        </div>
        <div className="canvas-body">
          <div className="card-brand-logo-name">
            <div
              className="card-logo-div"
              style={{
                color: data.textColor,
                backgroundColor: data.themeColor,
              }}
            >
              {data?.logo ? (
                <img
                  width="72px"
                  alt="card-logo"
                  title={data.storeName}
                  className="card-logo-image"
                  src={getFullImageUrl(data?.logo)}
                />
              ) : (
                <p className="card-logo-name" style={{ color: data.textColor }}>
                  {data.storeName}
                </p>
              )}
            </div>
            <p>{data.storeName}</p>
          </div>
          <div className="store-details">
            <span>{activeStores?.length} Stores</span>
            <div className="all-store-list">
              {activeStores?.map((store) => (
                <div
                  className="store-list"
                  key={store?._id || store?.id}
                  onClick={() => handleStoreClick(store)}
                >
                  <span>{store?.name}</span>
                  <img alt="arrow-right" src="/assets/icons/arrow-right.svg" />
                </div>
              ))}
            </div>
          </div>
          <div className="how-to-redeem">
            <h3>How to Redeem?</h3>
            <p>
              Give your mobile number to the staff on your next purchase and ask
              them to redeem.
            </p>
          </div>
          <PoweredByReeloFooter />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AllStoresCanvas;
